import React from 'react'
import ProductItem from '../../../../components/public/pages/home/productItem'

const WholeSale = ({Products}) => {
    const Columns = 8
  return (
    <div className='public_home_explore_b2c'>
        <div className='public_home_product_grid_1_container'>
            <div className='public_home_product_grid_1_title'>
                <div className='public_home_product_grid_1_title_details'>
                    <h4>{'Whole Sale'}</h4>
                    <p>{'For business building tools'}</p>
                </div>
            </div>
            <div className='public_home_product_grid_1_products_wrapper'>
                <div className='public_home_product_grid_1_products_old'>
                {
                    Products.slice(0, parseInt(Columns)).map((product,index)=>{
                        return(
                            <div style={{width:String((100/(parseInt(Columns)))-0.2)+"%", marginTop:'0.2%'}} key={index}>
                                <ProductItem Product={product} />
                            </div>
                        )
                    })
                }
                </div>
            </div>
        </div>
    </div>
  )
}

export default WholeSale
